import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, ContactState} from '../types'
import {apiUrl} from '@/config/service'
import axios from 'axios'

type ContactGetter = GetterTree<ContactState, RootState>

const state: ContactState = {
  contact: null
}

export const getters: ContactGetter = {
  contactGetter: (state) => state.contact
}

export const actions: ActionTree<ContactState, RootState> = {
  async getContactByIdAction({commit}, id) {
    commit('resetContactMutation')
    const {data} = await axios.get(`${apiUrl}/contact/${id}`)
    commit('getContactByIdMutation', data)
    return data
  },
  async createContactAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/contact`, formParams)
    return data
  },
  async updateContactAction({commit}, {id, formParams}) {
    const {data} = await axios.put(`${apiUrl}/contact/${id}`, formParams)
    return data
  },
  async deleteContactAction({commit}, id) {
    const {data} = await axios.delete(`${apiUrl}/contact/${id}`)
    return id
  }
}

const mutations: MutationTree<ContactState> = {
  getContactByIdMutation(state, data) {
    state.contact = data
  },
  resetContactMutation(state) {
    state.contact = null
  }
}

export const contact: Module<ContactState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
